<script>
import { ref, onMounted, onBeforeUnmount, defineComponent } from 'vue'

export default defineComponent({
  name: 'UiClickOutside',
  props: {
    do: {
      type: Function,
    },
  },
  setup(props, { slots }) {
    const root = ref()
    const listener = e => {
      if (!root.value) return
      const [target] = root.value
      if (e.target === target || target.contains(e.target)) {
        return
      }
      props.do()
    }

    onMounted(() => {
      document.addEventListener('click', listener, { passive: true })
    })
    onBeforeUnmount(() => {
      document.removeEventListener('click', listener);
    })
    return () => slots.default({ ref: root })
  },
})

</script>
